import React, { Component, PropTypes } from 'react';
import Spinner from 'components/Material/Spinner';
import ClassNames from 'classnames';
import {
  RaisedButton,
  IconButton,
  List,
  ListItem,
  CircularProgress,
  Styles,
  Checkbox,
  Toggle
} from 'material-ui';
import * as SvgIcons from 'components/Material/SvgIcons';
import Message from 'services/Message';

import { translate as _l } from 'oxygen-i18n';

addTranslations({
  ['en-US']: {
    totalNumberOfTasks: 'Total number of tasks',
    correctAnswers: 'Correct answers',
    pagesViewed: 'Pages viewed'
  },
  ['sv-SE']: {
    totalNumberOfTasks: 'Total antal uppgifter',
    correctAnswers: 'Korrekta svar',
    pagesViewed: 'Sedda sidor'
  }
});

let { Spacing } = Styles;
let { ContentClear, ContentSend, MapsBeenhere } = SvgIcons;

export default class SimpleOverview extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    limitToMax: PropTypes.number,
    readable: PropTypes.string,
    keyProperty: PropTypes.string,
    title: PropTypes.string,
    expires: PropTypes.string,
    role: PropTypes.string,
    onSelect: PropTypes.func,
    onTouchTapRightIcon: PropTypes.func,
    onTouchTapLeftIcon: PropTypes.func,
    onCheck: PropTypes.func,
    onTouchTapRightToggle: PropTypes.func,
    onTouchTapLeftToggle: PropTypes.func,
    items: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    user: PropTypes.object
  };

  static defaultProps = {
    limitToMax: 0,
    readable: 'name',
    keyProperty: 'id',
    expires: 'expires',
    role: 'role',
    loading: false,
    items: []
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  constructor() {
    super(...arguments);
    this.state = {
      collapsed: false,
      ifToggled:
        this.props.items &&
        this.props.items.map(item => {
          item.role == 'admin';
        }),
      expanded: false,
      clicked: false
    };
  }

  select(item) {
    if (this.props.onSelect) {
      this.props.onSelect(item);
    }
  }

  toggle() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  onTouchTapRightIcon(item) {
    if (this.props.onTouchTapRightIcon) {
      this.props.onTouchTapRightIcon(item);
    }
  }

  onTouchTapLeftIcon(item) {
    if (this.props.onTouchTapLeftIcon) {
      this.props.onTouchTapLeftIcon(item);
    }
  }

  onCheck(item) {
    if (this.props.onCheck) {
      this.props.onCheck(item);
    }
  }

  onToggleItem(item) {
    if (this.props.onTouchTapRightToggle) {
      this.props.onTouchTapRightToggle(item);
    }
  }

  render() {
    let children = [];
    const {
      expires,
      keyProperty,
      readable,
      loading,
      limitToMax,
      removable,
      role,
      progress
    } = this.props;

    const { expanded } = this.state;
    const { getIntlMessage } = this.context;

    let items;
    if (limitToMax > 0 && !expanded) {
      items = this.props.items.slice(0, limitToMax);
    } else {
      items = this.props.items;
    }
    if (loading) {
      children.push(<CircularProgress mode="indeterminate" key="spinner" />);
    } else {
      children = this.props.items && this.props.items.map(item => {
        const expires = item.ucpInfo && item.ucpInfo.expires;
        let expiration, resendButton, checkBoxItem, removeButton;
        if (expires) {
          expiration = ` (${this.context.getIntlMessage('course.access')}${expires.slice(0, 10)})`;
          resendButton = (
            <IconButton
              onTouchTap={this.onTouchTapLeftIcon.bind(this, item)}
              tooltip="Resend Invitation"
              tooltipPosition="top-right"
            >
              <ContentSend />
            </IconButton>
          );
        } else {
          expiration = '';
          resendButton = null;
        }

        const isActivePropExists = Object.keys(item).includes('active');
        //check if user is in the user list, ensure to not delete himself, unless the user is the main admin
        if (removable) {
          removeButton = (
            <div>
              <IconButton
                onTouchTap={this.onTouchTapRightIcon.bind(this, item)}
                tooltip={this.context.getIntlMessage('invitation.remove')}
                tooltipPosition="top-left"
              >
                <ContentClear />
              </IconButton>
            </div>
          );
        } else if (
          parseInt(item && item.id, 10) ==
            parseInt(this.props.user && this.props.user.id, 10) &&
          this.props.user &&
          !this.props.user.role.editor
        ) {
          removeButton = null;
        } else if (
          item &&
          item.file_id &&
          this.props.user &&
          !this.props.user.role.editor
        ) {
          //check if item is a course and if the user is not the main admin to avoid the user to delete the course from the group
          removeButton = null;
        } else if (!item.active && isActivePropExists) {
          removeButton = null;
        } else {
          removeButton = (
            <div>
              <IconButton
                onTouchTap={this.onTouchTapRightIcon.bind(this, item)}
                tooltip={this.context.getIntlMessage('invitation.remove')}
                tooltipPosition="top-left"
              >
                <ContentClear />
              </IconButton>
            </div>
          );
        }

        const progressItem =
          progress && progress.filter(obj => obj.id === item.id)[0];

        const prog = progressItem && (
          <div style={{ paddingTop: 5, paddingLeft: 5, fontSize: '14px' }}>
            Progress:
            <strong>{Math.round(progressItem.progress * 100)}% </strong>
            {_l`totalNumberOfTasks`}:<strong>{progressItem.taskTotal} </strong>
            {_l`correctAnswers`}:<strong> {progressItem.tasksCorrect} </strong>
            {_l`pagesViewed`}:
            <strong>
              {progressItem.pageViewed} / {progressItem.pageTotal}
            </strong>
          </div>
        );

        return (
          <ListItem
            key={item[keyProperty]}
            leftCheckbox={checkBoxItem}
            onTouchTap={this.select.bind(this, item)}
            primaryText={`${item[readable]} ${expiration}`}
            secondaryText={prog}
            leftIcon={resendButton}
            rightToggle={
              item[role] &&
              (parseInt(item && item.id, 10) !=
                parseInt(this.props.user && this.props.user.id, 10) &&
                this.props.user &&
                this.props.user.role.owner) ? (
                <Toggle
                  label={this.context.getIntlMessage('invitation.admin')}
                  toggled={item[role] == 'admin'}
                  style={{ right: '50px', width: '120px', fontSize: 'x-small' }}
                  onToggle={this.onToggleItem.bind(this, item)}
                />
              ) : null
            }
            rightIconButton={removeButton}
          />
        );
      });
    }
    const itemsLength = this.props.items && this.props.items.length;
    const loadMore = !expanded && itemsLength > items.length;
    const hide =
      expanded && limitToMax > 0 && this.props.items.length > limitToMax;
    return (
      <List
        subheader={this.props.title + '(' + itemsLength + ')'}
        style={{
          paddingTop: Spacing.desktopGutter,
          backgroundColor: '#FFFFFF'
        }}
        subheaderStyle={{
          fontSize: 24,
          borderStyle: 'none none solid none',
          borderWidth: '1px',
          borderColor: 'rgba(0, 0, 0, 0.12)'
        }}
      >
        {this.props.children}
        {children}
        {loadMore && (
          <RaisedButton
            secondary
            fullWidth
            onTouchTap={this.toggleExpand}
            label={getIntlMessage('ozitor.more')}
          />
        )}
        {hide && (
          <RaisedButton
            secondary
            fullWidth
            onTouchTap={this.toggleExpand}
            label={getIntlMessage('ozitor.less')}
          />
        )}
      </List>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/SimpleOverview.js